<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<v-col>
					<p class="title">Financing</p>
				</v-col>
				<v-col>

					<div>Coming Soon..</div>
					<!-- <template>
						<v-form ref="form">
							<v-container>
								<v-row>
									<v-col
									cols="12"
									md="4"
									>
									<v-text-field
									v-model="form.title"
									:counter="10"
									:rules="[v => !!v || 'Item is required']"
									label="Title"
									required
									></v-text-field>
								</v-col>

								<v-col
								cols="12"
								md="4"
								>
								<v-text-field
								v-model="form.description"
								:counter="60"
								:rules="[v => !!v || 'Item is required']"
								label="Description"
								required
								></v-text-field>
							</v-col>

							<v-col
							cols="12"
							md="4"
							>
							<v-select
							v-model="select"
							:items="items"
							:rules="[v => !!v || 'Item is required']"
							label="Discount Percent %"
							required
							></v-select>
						</v-col>
						<v-btn class="mr-4 primary" @click="submit">Add</v-btn>
					</v-row>
				</v-container>
			</v-form>
		</template> -->
	</v-col>
	<v-card>
		<v-card-text>
			<v-container>
				<!-- <template v-for="(item, index) in discounts">
					<v-list-item :key="item.description+index">
						<template v-slot:default="{ active, toggle }">
							<v-list-item-content>
								<v-list-item-title v-text="`Title - ${item.title}`"></v-list-item-title>
								<v-list-item-subtitle class="text--primary" v-text="`Description - ${item.description}`"></v-list-item-subtitle>
								<v-list-item-subtitle v-text="`Amount - ${item.amount}`"></v-list-item-subtitle>
							</v-list-item-content>

							<v-list-item-action>
								<v-btn v-if="item.title != 'None'" @click="delete(item.id)" color="#D32F2F" dark class="ml-2 mt-1">
									<v-icon medium class="darken-4 d-inline pr-1"> delete </v-icon>
								</v-btn>
							</v-list-item-action>
						</template>
					</v-list-item>
				</template> -->
			</v-container>
		</v-card-text>
	</v-card>
</v-col>
</v-row>
</v-container>
</template>

<script>
import firebase from '@/helpers/firebaseConfig'
const db = firebase.firestore()
export default {
	name: 'Discounts',
	components: {

	},
	data(){
		return {
			form: {
				title:'',
				description: '',
				amount: ''
			},
			select: null,
			items: [
			'.05',
			'.10',
			'.15',
			'.20',
			'.25',
			'.30',
			'.35',
			'.40',
			'.45',
			'.50',
			],
		}
	},
	computed: {
		discounts(){
			return this.$store.state.discounts
		}
	},
	methods: {
		delete(item){
			console.log(item)
		},
		submit(){
			db.collection('discounts').add({...this.form, cId: this.$store.state.user.cId})
			.then(()=>{
				this.reset()
			})
		},
		reset () {
			this.$refs.form.reset()
		},
	}

}
</script>
<style type="text/css" scoped>
</style>